import React from 'react';
import { MapPin, Mail, Phone } from 'lucide-react';
import { Logo } from './ui/Logo';
import { useLanguage } from '../context/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-navy-dark text-white/70 py-12 border-t border-white/10" data-id="element-180" data-mp="32onl753ftsa0">
      <div className="container mx-auto px-6 md:px-12" data-id="element-181" data-mp="36oy1baky1z2l">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-182" data-mp="36nd5lhmw8a35">
          <div className="col-span-1 md:col-span-2" data-id="element-183" data-mp="3ugbsveb9tqmi">
            <Logo variant="light" className="mb-6" data-id="element-184" data-mp="38qz78i6g9vx" />
            <p className="max-w-sm mb-6" data-id="element-185" data-mp="387drhtbj3d5">{t.footer.desc}</p>
            <ul className="space-y-3 text-sm" data-id="element-186" data-mp="3levgj10wbefn">
              <li className="flex items-start gap-3" data-id="element-187" data-mp="3le2jirrqo3ap">
                <MapPin className="w-5 h-5 text-sand flex-shrink-0 mt-0.5" data-id="element-188" data-mp="3qcx8kbgauo39" />
                <span data-id="element-189" data-mp="29z6ucbvgujfw">
                  C/ Cuescaro, 14, 38639, Las Chafiras, Santa Cruz de Tenerife
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-190" data-mp="2ez1kgd7f34zw">
                <Mail className="w-5 h-5 text-sand flex-shrink-0" data-id="element-191" data-mp="3l9k7bh9idvfe" />
                <a href="mailto:info@homefort.es" className="hover:text-white transition-colors" data-id="element-192" data-mp="3l9si93m2mqny">
                  info@homefort.es
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-193" data-mp="3q8mzw28ay96h">
                <Phone className="w-5 h-5 text-sand flex-shrink-0" data-id="element-194" data-mp="3q7ty7fo7a9v7" />
                <a href="tel:+34689621262" className="hover:text-white transition-colors" data-id="element-195" data-mp="82ihs7hrf0lp">
                  (+34) 689 621 262
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-196" data-mp="hs21tgh7l0i5">
            <h4 className="text-white font-medium mb-4" data-id="element-197" data-mp="huo4p2t5mru1">{t.footer.links}</h4>
            <ul className="space-y-2" data-id="element-198" data-mp="cuija4dha1ke">
              <li data-id="element-199" data-mp="qt8fziwdxz88">
                <a href="#entorno" className="hover:text-white transition-colors" data-id="element-200" data-mp="qsqfub6lr0v1">
                  {t.nav.entorno}
                </a>
              </li>
              <li data-id="element-201" data-mp="tw5wy2alzikm">
                <a href="#calidades" className="hover:text-white transition-colors" data-id="element-202" data-mp="two43tyt7h7b">
                  {t.nav.calidades}
                </a>
              </li>
              <li data-id="element-203" data-mp="13r7mgz8sqmnq">
                <a href="#disponibilidad" className="hover:text-white transition-colors" data-id="element-204" data-mp="18k0qtm0crsza">
                  {t.nav.disponibilidad}
                </a>
              </li>
              <li data-id="element-205" data-mp="1hk5xtv1mwpcx">
                <a href="#contacto" className="hover:text-white transition-colors" data-id="element-206" data-mp="1hjnvcgodpewk">
                  {t.nav.contacto}
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-207" data-mp="1rgsfyc2kt2b9">
            <h4 className="text-white font-medium mb-4" data-id="element-208" data-mp="3ob55u0ppux42">{t.footer.legal}</h4>
            <ul className="space-y-2" data-id="element-209" data-mp="3od857bcre2lg">
              <li data-id="element-210" data-mp="3t9q6204yxgsi">
                <a href="#" className="hover:text-white transition-colors" data-id="element-211" data-mp="3tb9l5new1lsp">
                  {t.footer.legalLinks.notice}
                </a>
              </li>
              <li data-id="element-212" data-mp="25oexs0w4xofq">
                <a href="#" className="hover:text-white transition-colors" data-id="element-213" data-mp="25nvlazp97s93">
                  {t.footer.legalLinks.privacy}
                </a>
              </li>
              <li data-id="element-214" data-mp="21kfmbwpppft8">
                <a href="#" className="hover:text-white transition-colors" data-id="element-215" data-mp="1wnyyl3mfd3go">
                  {t.footer.legalLinks.cookies}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-216" data-mp="2pbuu4509cpbv">
          <p data-id="element-217" data-mp="2kc8ddll80qyb">
            &copy; {new Date().getFullYear()} {t.footer.rights}
          </p>
          <p data-id="element-218" data-mp="2fd5aa6oswusz">{t.footer.disclaimer}</p>
        </div>
      </div>
    </footer>;
}